import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import Helmet from 'react-helmet';

import { getLanguages, getLanguage, getJurisdictions } from 'actions/app';

import localeDe from 'react-intl/locale-data/de';
import localeEn from 'react-intl/locale-data/en';
import localeEs from 'react-intl/locale-data/es';
import localeFr from 'react-intl/locale-data/fr';
import localeRu from 'react-intl/locale-data/ru';
import localeZh from 'react-intl/locale-data/zh';

addLocaleData([
  ...localeDe,
  ...localeEn,
  ...localeEs,
  ...localeFr,
  ...localeRu,
  ...localeZh
]);

// IntlProvider requires a key, which should be set to the locale
// Changing the locale/key causes intl to update properly
// However in our setup we go from the frontend default 'en' to a backend api delivered 'en'
// They key does not change and so does not trigger an update
// Therefore the default locale in the store is now 'default'
// which changes to 'en' if either the backend dictionary loads or fails, triggering an update

export class AppProvider extends React.Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getLanguages());
    dispatch(getLanguage('en'));
    dispatch(getJurisdictions());
  }

  render() {
    const { locale, messages, children } = this.props;
    return (
      <React.Fragment>
        <Helmet htmlAttributes={ { lang: locale } } />
        <IntlProvider locale={ locale } messages={ messages } key={ locale }>
          { children }
        </IntlProvider>
      </React.Fragment>
    );
  }
}

AppProvider.propTypes = {
  dispatch: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  messages: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

AppProvider.defaultProps = {
  children: null
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: { locale, messages }
  } = state;

  return {
    locale,
    messages
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppProvider);
